import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import Contact from './components/Contact'
import Homepage from './components/Homepage'
import Error from './components/Layout/Error'
import Layout from './components/Layout/Layout'
import MovieDetail from './components/Movies/MovieDetail'
import Populer from './components/Movies/Populer'
import TopRated from './components/Movies/TopRated'
import Upcoming from './components/Movies/Upcoming'

function Routers() {
    return (
        <Router basename={'/removieact'}>
            <Switch>    
                <Route>
                <Layout>
                    <Switch>
                    <Route path='/' exact component={Homepage} />
                    <Route path="/populer" exact component={Populer}></Route>
                    <Route path="/top-rated" exact component={TopRated}></Route>
                    <Route path="/upcoming" exact component={Upcoming}></Route>
                    <Route path="/contact" exact component={Contact}></Route>
                    <Route path="/movie-detail/:id" exact component={MovieDetail}></Route>
                    <Route component={Error}></Route>
                    </Switch>
                </Layout>
                </Route>
            </Switch>
        </Router>
    )
}

export default Routers
